/**
 * <strong>Properties:</strong><br>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DescriptionMixin|description}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DisabledMixin|disabled}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/HorizontalAlignmentMixin|horizontalAlignment}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/IconMixin|icon}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/IconAlignmentMixin|iconAlignment}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TagMixin|tag}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TextMixin|text}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/VerticalAlignmentMixin|verticalAlignment}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/SizeMixin|width, height}</li>
 * <br>
 * <br>
 * <strong>Events:</strong>
 * <br>
 * <br>
 * <li>No events</li>
 * <br>
 * <br>
 * <strong>Example:</strong>
 * <br>
 * <br>
 * For a working example, see the {@link http://inside-files/dev/eps/WIT/WebWidgets/Gallery/Gallery/#label_anchor|gallery}
 * <br>
 * <br>
 * @module mw-form/Label
 *
 * @copyright Copyright 2015-2018 The MathWorks, Inc.
 */

// TODO: Remove _CSSStateMixin dependency, as seen in SplitButton and ToggleSplitButton

define([
    "dojo/_base/declare",

    "dijit/_WidgetBase",

    "dijit/_Contained",
    "dijit/_CssStateMixin",
    "dijit/_FocusMixin",
    "dijit/_TemplatedMixin",

    "mw-form/mixins/property/TagMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "mw-form/mixins/property/DisabledMixin",
    "mw-form/mixins/property/HorizontalAlignmentMixin",
    "mw-form/mixins/property/IconAlignmentMixin",
    "mw-form/mixins/property/IconMixin",
    "mw-form/mixins/property/SizeMixin",
    "mw-form/mixins/property/TextMixin",
    "mw-form/mixins/property/VisualFamilyMixin",
    "mw-form/mixins/property/VerticalAlignmentMixin",
    "mw-form/mixins/IconAndTextSizingMixin",
    "mw-form/mixins/PreventSelectionMixin",
    "mw-form/mixins/AccessibilityClickMixin",
    "mw-form/mixins/mixinDependencyValidator",
    "mw-form/mixins/AriaLabelledByMixin",
    "dojo/text!./templates/Label.html"
], function (declare, _WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin, TagMixin, DescriptionMixin,
             DisabledMixin, HorizontalAlignmentMixin, IconAlignmentMixin, IconMixin, SizeMixin, TextMixin,
             VisualFamilyMixin, VerticalAlignmentMixin, IconAndTextSizingMixin, PreventSelectionMixin,
             AccessibilityClickMixin, mixinDependencyValidator, AriaLabelledByMixin, template) {

    return declare(mixinDependencyValidator.validate([_WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin,
        TagMixin, DescriptionMixin, DisabledMixin, HorizontalAlignmentMixin, IconAlignmentMixin, IconMixin, SizeMixin, TextMixin, VisualFamilyMixin,
        VerticalAlignmentMixin, IconAndTextSizingMixin, PreventSelectionMixin, AccessibilityClickMixin, AriaLabelledByMixin]), {
        baseClass: "mwWidget mwLabel",
        templateString: template,
        _paddingAndBorder: 0,

        //Do not have tab index on label => override from disabled Mixin
        _setTabIndexOnNode: function () {

        }
    });

});
